import {
    H2,
    Regular,
    LargePrimaryButton
} from '@worthy-npm/clarity';

import React from "react";

class MaintenancePage extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    render() {

        return (<div key='maintenance-container' className={'maintenance-container'}>
            <H2 text={"We'll be Back Soon"} />
            <br/>
            <br/>
            <Regular text={"The site is currently down for some scheduled maintenance. But worry not, we’ll be back getting you the best value for your jewelry in no time!"}/>
            <br/>
            <br/>
            <LargePrimaryButton text={'Visit Our Blog'} click={() => window.location = 'https://www.worthy.com/blog'} />
        </div>)
    }

}
export default MaintenancePage;